<template>
  <ContentWrapper>
    <div class="file-search" v-show="data.params.mode=='list'">
      <div class="card-body">
        <!-- 항목 검색 -->
        <div class="form-group align-items-center row mr-3 mb-4">
          <LabelSelect label="단원" :opt="depth1Opts" :value="depth1Value" @changeItem="onchangeDepth1" />
          <LabelSelect label="차시" :opt="depth2Opts" :value="depth2Value" @changeItem="onchangeDepth2" />
        </div>
        <div class="form-row align-items-center">
          <sch-text resetable="yes" label="검색어" :data="data" @search="search" @reset="reset"/>
          <div class="form-group no-margin row ">
          <div class="col-auto">
            <b-button-group>
              <!-- <button :disabled="!isNewExtFile" @click="popupShowDepthYfileNewList = true" class="btn btn-dark mb-2 ml-3">Y클라우드 신규자료 확인</button> -->
              <button @click="isNewExtFile ? (popupShowDepthYfileNewList = true) : (popupAlert++)" class="btn btn-dark mb-2 ml-3">Y클라우드 신규자료 확인</button>
            </b-button-group>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div div class="content-heading mt-1">
        <div>검색목록</div>
    </div>
    <div class="card card-default">
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered">
            <colgroup>
              <col width="3%"/>
              <col width="11%"/>
              <col width="22%"/>
              <col width="*"/>
              <col width="13%"/>
              <col width="20%"/>
            </colgroup>
            <tr>
              <td><input type="checkbox" v-model='checkedAll' @change="SelectItemAll(data.list , 'top')"></td>
              <td style="text-align:center" @click="dataAction.sort(search,'contents_id')">외부개체ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="dataAction.sort(search,'contents_nm')">개체명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="dataAction.sort(search,'contents_upload_file_nm')">파일명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="dataAction.sort(search,'contents_level3_type_cd_nm')">분류<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="dataAction.sort(search,'update_dt')">수정일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>

          <tr v-for="(item, index) in data.list" :key="index">
            <td input-type><input type="checkbox" v-model='checked[item.contentsId]' @change="SelectItem(index,'top')" :checked="checked[item.contentsId] == true ? 'true' : 'false'"></td>
            <td>{{ item.contentsId }}</td>
            <td>{{ item.contentsNm }}</td>
            <td>{{ item.contentsUploadFileNm }}</td>
            <td>{{ item.contentsLevel3TypeCdNm }}</td>
            <td>{{ item.updateDt }}</td>
          </tr>
          </table>
        </form>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" 
            @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="popupClose('yfile')" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">취소</b-button>
          <b-button @click="SelectItemShow(); " class="btn btn-xs btn-outline-danger mr-2" variant="outline-info mr-2">선택목록 이동</b-button>
          <b-button @click="save('list')" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">바로저장</b-button>
        </div>
      </div>
    </div>
    <div div class="content-heading mt-1">
        <div>선택목록</div>
    </div>
    <div class="card card-default">
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered">
            <colgroup>
              <col width="3%"/>
              <col width="11%"/>
              <col width="22%"/>
              <col width="*"/>
              <col width="13%"/>
              <col width="20%"/>
            </colgroup>
           <tr>
              <td><input type="checkbox" v-model='selectCheckedAll' @change="SelectItemAll(selectShowData , 'bottom')"></td>
              <td style="text-align:center" @click="selectSort('contentsId')">외부개체ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="selectSort('contentsNm')">개체명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="selectSort('contentsUploadFileNm')">파일명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="selectSort('contentsLevel3TypeCdNm')">분류<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="selectSort('updateDt')">수정일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>

          <tr v-for="(item, index) in selectShowData" :key="index">
            <td input-type><input type="checkbox" v-model='selectChecked[item.contentsId]' @change="SelectItem(index,'bottom')" :checked="selectChecked[item.contentsId] == true ? 'true' : 'false'"></td>
            <td>{{ item.contentsId }}</td>
            <td>{{ item.contentsNm }}</td>
            <td>{{ item.contentsUploadFileNm }}</td>
            <td>{{ item.contentsLevel3TypeCdNm }}</td>
            <td>{{ item.updateDt }}</td>
          </tr>
          </table>
        </form>
      </div>
      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="popupClose('yfile')" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">취소</b-button>
          <b-button @click="SelectItemHide();" class="btn btn-xs btn-outline-danger mr-2" variant="outline-info mr-2">선택취소</b-button>
          <b-button @click="save('checklist')" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">저장</b-button>
        </div>
      </div>
    </div>
    <!-- // 상세 -->
    <b-modal id="newListModal" size="xl" title="Y클라우드 신규자료 추가 리스트" v-model="popupShowDepthYfileNewList" ok-only>
      <YCsTextBookFilesNewList :bookId="bookId" :bookName="bookName" key="bookId" :totalCount="totalCount" :ignoreContentsIds="ignoreList" @modal-state="popupClose"/>
      <Loading :is-full-page="true"/>
    </b-modal>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, watch, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getContentsMstList, getTextbookContentsMstList, getContentsMstItem, saveContentsMst, deleteContentsMst} from "@/api/ext/ContentsMstApi"
import {getCsFileList, getCsFileItem, getCsFileListByOrgContSeq, saveCsFile, deleteCsFile} from "@/api/cs/CsFileApi"
import {getCsFileMappingList, getCsFileMappingItem, saveCsFileMapping, deleteCsFileMapping,saveCsFileMappingList} from "@/api/cs/CsFileMappingApi"
import {getTextbookAtrbRelInfoList} from "@/api/ext/TextbookAtrbRelInfoApi";
import {saveNewTextbookContents, updateTextbookContents} from "@/api/lm/LmTextBookApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject, fileDivCd, fileDivCdMap} from "@/utils/Constants";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import Datepicker from 'vuejs-datepicker'
import LabelSelect from '../../components/Common/LabelSelect'
import YCsTextBookFilesNewList from "../cs/YCsTextBookFilesNewList"

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {SchDateRange, SchText, Pagenation, Datepicker, LabelSelect, YCsTextBookFilesNewList, Loading},
  props: {
    bookId: '',
    bookName: '',
    extFileId: '',
    atrbInfo : '',
    pContSeq1 : '',
    pContSeq2 : '',
    orgContSeq : '',
  },
  setup(props, context) {
    const popupShowDepthYfileNewList = ref(false); //Ycloud 신규 자료 리스트 팝업
    const popupAlert = ref(0); //Ycloud 신규 자료 없음 alert.
    watch(popupAlert, (newValue, oldValue) => alert('신규자료가 없습니다.'))

    const depth1Opts = ref([{value: '', text: '전체'}]);
    const depth1Value = ref('');
    const onchangeDepth1 = (value) => { depth1Value.value = value; loadDepth2(); };

    const depth2Opts = ref([{value: '', text: '전체'}]);
    const depth2Value = ref('');
    const onchangeDepth2 = (value) => { depth2Value.value = value; };

    const schOptions = [
      {value: 'contents_id', text: '파일 아이디'},
      {value: 'contents_nm', text: '개체명'},
      {value: 'contents_upload_file_nm', text: '원본파일명'},
    ];
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject)
    const selectDataT = reactive([]);
    const selectDataB = reactive([]);
    const selectShowData = reactive([]);
    const savelist = [];
    const checked = reactive([]);
    const checkedAll = ref(false);
    const selectChecked = reactive([]);
    const selectCheckedAll = ref(false);

    const modal_state = ref(true);

    const csFiles = [];
    const ignoreList = []; // 스마트스쿨 해당 교과서에 관련된 모든 객체의 ext_file_id들

    const totalCount = ref(0); // Ycloud 해당 교과서에 관련된 모든 객체의 갯수. 
    const isNewExtFile = ref(false); // Ycloud 해당 교과서에 새로운 객체가 있는지 여부.

    data.schOptions = schOptions // 검색 type 선택

    console.log('## props:',props)

    const loadDepth1 = async () => {
      if (props.bookId) {
        let _param = {
          textbookId: props.bookId,
          relAtrbTypeCd: '1001',  /*1001:단원,1002:차시,1003:코너, 1004:개체 */
          relAtrbDepth: 1,
        }
        let result = await getTextbookAtrbRelInfoList(_param);
        // data.list = result.data;

        let opts = [{value:'', text:'전체'}];
        result.data.map((item, i)=>{
            opts.push({
                value: item.relAtrbId,
                text: item.relAtrbTitle
            })
        });
        depth1Opts.value = opts;
      }
    }
    const loadDepth2 = async () => {
      if (depth1Value.value) {
        let _params = {
          relPrntsAtrbId: depth1Value.value,
          relAtrbTypeCd: '1002' // 차시
        }
        let result = await getTextbookAtrbRelInfoList(_params);
        data.subList = result.data;

        let opts = [{value:'', text:'전체'}];
        result.data.map((item, i)=>{
            opts.push({
                value: item.relAtrbId,
                text: item.relAtrbTitle
            })
        });
        depth2Opts.value = opts;
      }
    }

    const dataAction = new TableActionClass(data);

    const loadData = async () => {
      console.log('####', 'loadData');
      // Y클라우드 자료와 비교를 위한 스마트스쿨의 CsFileList를 가져온다.
      csFiles.splice(0, csFiles.length);
      ignoreList.splice(0, ignoreList.length);
      let result = await getCsFileListByOrgContSeq({ contSeq : props.orgContSeq, });
      if (!!result.data) {
        result.data.forEach(row => {
          if (!!row.extFileId) {
            csFiles.push(row);
            ignoreList.push(row.extFileId);
          }
        });
      }

      // 단원
      loadDepth1();

      // search()
      // if (ignoreList.length > 0) data.params.ignoreContentsIdsStr = ignoreList.join('-');
      data.params.textbookId = props.bookId
      data.params.relAtrbId = depth2Value.value === '' ? depth1Value.value : depth2Value.value
      let _params = data.params;
      var context = {};
      context["getTextbookContentsMstList"] = getTextbookContentsMstList;  // get list
      await dataAction.execute("getTextbookContentsMstList", context, _params);
      totalCount.value = data.count;

      // 새로운 객체가 있는지 여부
      if (totalCount.value > ignoreList.length) {
        isNewExtFile.value = true;
      } else {
        let isIn = true;
        data.list.every(e => {isIn = ignoreList.includes(e.contentsId); return isIn; });
        isNewExtFile.value = !isIn;
      }
    }
    onMounted(loadData)

    const isCheckedAll = (location) => {
      let isAll = true;
      if(location =='top'){
        data.list.every(e => {isAll = checked[e.contentsId]; return isAll; });
        checkedAll.value = isAll;
      } else { // bottom
        selectShowData.every(e => {isAll = selectChecked[e.contentsId]; return isAll; });
        selectCheckedAll.value = isAll;
      }
    }

    const SelectItem = (i, location) => {
      if(location =='top') {
        if (checked[data.list[i].contentsId]) {
          selectDataT.push(data.list[i]);
        } else {
          selectDataT.map((row, j ) => {
            if(row.contentsId === data.list[i].contentsId){ selectDataT.splice(j,1); }
          });
        }
      } else { // bottom
        if (selectChecked[selectShowData[i].contentsId]) {
          console.log('SelectItem bottom checked');
          selectDataB.push(selectShowData[i]);
        } else {
          console.log('SelectItem bottom unchecked');
          selectDataB.map((row, j ) => {
            if(row.contentsId === selectShowData[i].contentsId){ selectDataB.splice(j,1); }
          });
        }
      }
      isCheckedAll(location);
    }

    const SelectItemAll = (item, location) => {
      item.map((row, j ) => {
        if(location == 'top'){
          if(checkedAll.value){
            selectDataT.push(row);
            checked[row.contentsId] = true;
          }else{
            const idx = selectDataT.findIndex((item) => {return item.contentsId === row.contentsId});
            if (idx > -1) selectDataT.splice(idx, 1);
            checked[row.contentsId] = false;
          }
        }
       else{
          if(selectCheckedAll.value){
            selectDataB.push(row);
            selectChecked[row.contentsId] = true;
          }else{
            const idx = selectDataB.findIndex((item) => {return item.contentsId === row.contentsId});
            if (idx > -1) selectDataB.splice(idx, 1);
            selectChecked[row.contentsId] = false;
          }
        }
      });
    }

    const SelectItemHide = () => {
      console.log('SelectItemHide: item: ', selectDataB.length);
      selectDataB.forEach(row => {
          const idx = selectShowData.findIndex((item) => {return item.contentsId === row.contentsId});
          if (idx > -1) selectShowData.splice(idx, 1);
          console.log(idx, row.contentsId);
          selectChecked[row.contentsId] = false;
      });

      selectDataB.splice(0,selectDataB.length);  
      selectCheckedAll.value = false;
    }

    const SelectItemShow = () => {
      let _temp = selectDataT.filter(row => selectShowData.findIndex((item) => {return item.contentsId === row.contentsId}) == -1); // 중복 체크
    
      _temp.map(row => { selectShowData.push(row); checked[row.contentsId] = false;});

      _temp = reactive([]);
      selectDataT.splice(0, selectDataT.length)
      checkedAll.value = false;
    }

    const popupClose = (version) => {
      if(version == 'yfilenewlist'){
        popupShowDepthYfileNewList.value = false;
      } else {
        context.emit('modal-state', 'yfile');
      }
    }

    const save = (type) => {
      let selData = [];
      if(type == 'list') {
        selData = selectDataT;
      } else {
        selData = selectDataB;
      }

      if(selData.length == 0 ){
        alert("선택된 개체가 없습니다.");
      } else {
        let fileSeq = [];
        let contSeq = (props.pContSeq2||0) > 0 ? props.pContSeq2 : (props.pContSeq1||0) > 0 ? props.pContSeq1 : props.orgContSeq;
        csFileSaveAndMapping(contSeq, fileSeq, selData);
      }
    }
    const csFileSaveAndMapping = async (contSeq, fileSeq, selData) => {
      // console.log(selData);

      let fileSeqList = [];
      const newData = [];
      const updateData = [];
      selData.forEach(row => {
        let csFile = csFiles.find(e => e.extFileId == row.contentsId);
        if (!!csFile) {
          fileSeqList.push(csFile.fileSeq);
          updateData.push(row);
        } else {
          newData.push(row);
        }
      });
      if (newData.length > 0) {
          // save csFile
          let result = await saveNewTextbookContents(newData);
          if (!!result.data && result.data.length > 0) {
            fileSeqList = fileSeqList.concat(result.data);
          }
      }
      if (updateData.length > 0) {
          // update csFile
          await updateTextbookContents(updateData);
      }

      savelist.splice(0, savelist.length);
      fileSeqList.forEach(e => savelist.push({ contSeq: contSeq, fileSeq: e }));

      await saveCsFileMappingList(savelist);
      context.emit('modal-state', 'yfile');
      context.emit('get-data', {
          contSeq : props.orgContSeq,
          atrbInfo : props.atrbInfo,
      });
    }

    const compare_asc = (a,b) => {
      const upperCaseA = a.toUpperCase();
      const upperCaseB = b.toUpperCase();
  
      if(upperCaseA > upperCaseB) return 1;
      if(upperCaseA < upperCaseB) return -1;
      if(upperCaseA === upperCaseB) return 0;
    }
    const compare_desc = (a,b) => {
      const upperCaseA = a.toUpperCase();
      const upperCaseB = b.toUpperCase();
  
      if(upperCaseA < upperCaseB) return 1;
      if(upperCaseA > upperCaseB) return -1;
      if(upperCaseA === upperCaseB) return 0;
    }
    let selectSortDir = 'desc';
    const selectSort = (key) => {
      selectSortDir = selectSortDir == 'asc' ? 'desc' : 'asc';
      let compare = compare_asc;
      if (selectSortDir == 'desc') compare = compare_desc;

      if (key == 'contentsId') {
        selectShowData.sort((a, b) => { return compare(a.contentsId, b.contentsId); });
      } else if (key == 'contentsNm') {
        selectShowData.sort((a, b) => { return compare(a.contentsNm, b.contentsNm); });
      } else if (key == 'contentsUploadFileNm') {
        selectShowData.sort((a, b) => { return compare(a.contentsUploadFileNm, b.contentsUploadFileNm); });
      } else if (key == 'contentsLevel2TypeCdNm') {
        selectShowData.sort((a, b) => { return compare(a.contentsLevel2TypeCdNm, b.contentsLevel2TypeCdNm); });
      } else if (key == 'contentsLevel3TypeCdNm') {
        selectShowData.sort((a, b) => { return compare(a.contentsLevel3TypeCdNm, b.contentsLevel2TypeCdNm); });
      } else if (key == 'updateDt') {
        selectShowData.sort((a, b) => { return compare(a.updateDt, b.updateDt); });
      }
    }
    

    return {
      popupShowDepthYfileNewList,
      popupAlert,
      depth1Opts,
      depth1Value,
      onchangeDepth1,
      depth2Opts,
      depth2Value,
      onchangeDepth2,
      data,
      selectDataT,
      selectDataB,
      savelist,
      selectShowData,
      isCheckedAll,
      SelectItem,
      SelectItemAll,
      SelectItemShow,
      SelectItemHide,
      checked,
      fileDivCd,
      selectChecked,
      selectCheckedAll,
      checkedAll,
      csFiles,
      ignoreList,
      totalCount,
      isNewExtFile,
      popupClose,
      fileDivCdMap,
      save,
      selectSort,
      ...methods(props, context),
      dataAction,
    }
  },
}

function methods(props, context) {
  var context = {};
  context["saveCsFile"] = saveCsFile;  // save item
  context["saveCsFileMappingList"] = saveCsFileMappingList; //file mapping
  context["getTextbookContentsMstList"] = getTextbookContentsMstList;  // get list

  // 목록
  async function search() {
    // if(this.ignoreList.length > 0) this.data.params.ignoreContentsIdsStr = this.ignoreList.join('-');
    this.data.params.textbookId = props.bookId
    this.data.params.relAtrbId = this.depth2Value === '' ? this.depth1Value : this.depth2Value
    let _params = this.data.params;
    await this.dataAction.execute("getTextbookContentsMstList", context, _params);
    this.isCheckedAll('top');
  }

  // 저장
  async function saveMapping(params) {
    return saveCsFileMappingList(params);
  }

  // 초기화
  async function reset() {
    this.depth1Value = '';
    this.depth2Value = '';
    // this.dataAction.clear();
    this.search();
  }

  return {reset, search, saveMapping}
}


</script>